import { useEffect, useState } from 'react';

import { useSendPollResult } from '@widgets/UserPoll/api/hooks';

export const useUserPoll = () => {
    const [isAnswered, setIsAnswered] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    const [skipBtn, setSkipBtn] = useState(false);
    const [userText, setUserText] = useState('');
    const sendResultMutation = useSendPollResult();

    const isMutating = sendResultMutation.isPending;
    const isMutatingSuccess = sendResultMutation.isSuccess;

    useEffect(() => {
        const timeout = setTimeout(() => setSkipBtn(true), 3000);

        return () => clearTimeout(timeout);
    }, []);

    const handlePollAnswer = async (fieldValue: string) => {
        const res = await sendResultMutation.mutateAsync({ answer: fieldValue });
        // const res = await sendResultMutation.mutateAsync({ answer: userText });
        if (res.data.status === 'success') {
            setIsAnswered(true);
        }
    };

    const handleFinishPoll = () => {
        setIsFinished(true);
    };

    const handleSkip = async () => {
        // reset({ userText: '' });
        handleFinishPoll();
    };

    const onChangeUserText = (text: string) => {
        setUserText(text);
    };

    useEffect(() => {
        let timeout = null;
        if (isAnswered) {
            timeout = setTimeout(() => handleFinishPoll(), 2000);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isAnswered]);

    return {
        skipBtn,
        userText,
        isAnswered,
        isMutating,
        isMutatingSuccess,
        isFinished,
        onChangeUserText,
        handlePollAnswer,
        handleFinishPoll,
        handleSkip,
    };
};
